import axios from 'axios';

export default class AppointmentSlot {
  constructor() {
    this.baseUrl = document.getElementById("hdnBaseUrl").value;
  }

  getSlots(data) {
    var url = this.baseUrl + `api/ClientPracticeSlot`;
    return axios.post(url, data);
  }

  bookAppointment(appointmentBookings) {
    var url = this.baseUrl +
      'api/WidgetDirectBooking';

    return axios.post(url, appointmentBookings);
  }
}



// WEBPACK FOOTER //
// ./src/api/AppointmentSlots.js